(() => {
  'use strict';
  if (window.GrowplayKlaviyoReviews) return;
  window.GrowplayKlaviyoReviews = true;
  const host = location.hostname;
  const previewLoader = document.querySelector('script[src*="/onsite/js/SknNPg/klaviyo.js"]');
  const company = host.includes('growplayusa.com') || host.includes('growplay-monkey-bars-usa.myshopify.com')
    ? 'SknNPg'
    : host.includes('growplay-uk.myshopify.com') || host.includes('uk.growplaymonkeybars.com')
      ? 'YsDfh9'
      : host.includes('growplay-monkey-bars-nz.myshopify.com') || host.includes('nz.growplaymonkeybars.com')
        ? 'XdkXaP' : previewLoader ? 'SknNPg' : '';
  if (!company) return;
  const selector = '.klaviyo-star-rating-widget, [id^="klaviyo-reviews"], [data-klaviyo-reviews], [data-klaviyo-product-reviews]';
  let timer;
  let renderedApi;
  const loader = () => document.querySelector('script[src*="/onsite/js/' + company + '/klaviyo.js"], script[data-gp-klaviyo-company="' + company + '"]');
  const ensureLoader = () => {
    if (loader()) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/' + company + '/klaviyo.js?company_id=' + company;
    script.dataset.gpKlaviyoCompany = company;
    document.head.append(script);
  };
  const render = () => {
    const api = window.klReviewsObject;
    if (!api || typeof api.renderWidgets !== 'function') return false;
    if (api !== renderedApi) {
      api.renderWidgets();
      renderedApi = api;
    }
    return true;
  };
  const init = () => {
    if (!document.querySelector(selector)) return;
    clearTimeout(timer);
    let attempts = 0;
    const check = () => {
      if (render()) return;
      if (++attempts < 50) timer = setTimeout(check, 500);
    };
    ensureLoader();
    check();
  };
  document.addEventListener('shopify:section:load', () => {
    renderedApi = undefined;
    init();
  });
  document.addEventListener('gp:klaviyo:refresh', event => {
    if (event.detail?.mounted) renderedApi = undefined;
    init();
  });
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init, {once: true});
})();
